import React from 'react';

interface WidgetErrorBoundaryState {
    hasError: boolean;
}

/**
 * Error boundary that isolates the SupportWidget from the host app (HELP-04).
 * A widget crash renders null — never propagates to the host ECU app.
 * Errors are logged via console.error only (no Sentry/XHR conflict).
 */
export class WidgetErrorBoundary extends React.Component<
    React.PropsWithChildren<object>,
    WidgetErrorBoundaryState
> {
    constructor(props: React.PropsWithChildren<object>) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_error: Error): WidgetErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo): void {
        console.error('[SupportWidget] Caught render error:', error, info);
    }

    render(): React.ReactNode {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    }
}
